import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'app-checkbox-input',
  standalone: true,
  imports: [MatCheckboxModule, ReactiveFormsModule],
  templateUrl: './checkbox-input.component.html',
  styleUrl: './checkbox-input.component.scss',
})
export class CheckboxInputComponent {
  @Input() label!: string;
  @Input() control!: FormControl;

  @Input() isDisabled: boolean = false;

  @Output() isChecked = new EventEmitter<boolean>();

  inputChanged(event: MatCheckboxChange): void {
    this.isChecked.emit(event.checked);
  }
}
